/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name base
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/complex/base}
*/
import base from './../base';
setReadOnly( ns, 'base', base );

/**
* @name complex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/cmplx}
*/
import complex from './../cmplx';
setReadOnly( ns, 'complex', complex );

/**
* @name ctors
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/ctors}
*/
import ctors from './../ctors';
setReadOnly( ns, 'ctors', ctors );

/**
* @name dtype
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/dtype}
*/
import dtype from './../dtype';
setReadOnly( ns, 'dtype', dtype );

/**
* @name dtypes
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/dtypes}
*/
import dtypes from './../dtypes';
setReadOnly( ns, 'dtypes', dtypes );

/**
* @name float32
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/complex/float32}
*/
import float32 from './../float32';
setReadOnly( ns, 'float32', float32 );

/**
* @name float64
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/complex/float64}
*/
import float64 from './../float64';
setReadOnly( ns, 'float64', float64 );

/**
* @name promotionRules
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/promotion-rules}
*/
import promotionRules from './../promotion-rules';
setReadOnly( ns, 'promotionRules', promotionRules );

/**
* @name reviveComplex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/reviver}
*/
import reviveComplex from './../reviver';
setReadOnly( ns, 'reviveComplex', reviveComplex );


// EXPORTS //

export default ns;
